module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isEdge && _vm.bannerActive) ? _c('div', {
    staticClass: "ie-edge-banner"
  }, [_c('div', {
    staticClass: "vert-center"
  }, [_vm._v("\n    Please switch browsers for the best viewing experience. We recommend\n    "), _c('a', {
    attrs: {
      "href": "https://www.google.ca/chrome/browser/desktop/index.html",
      "target": "_blank"
    }
  }, [_vm._v("Chrome")]), _vm._v(" or\n    "), _c('a', {
    attrs: {
      "href": "https://www.mozilla.org/en-US/firefox/new/",
      "target": "_blank"
    }
  }, [_vm._v("Firefox")]), _vm._v(".\n    "), _c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.disableBanner
    }
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca191a34","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/edgeBanner.vue
// module id = 565
// module chunks = 1